/*
 * The two floating buttons on phones (sweep 2026-10-21 bug 1): our chat bubble (bottom left, assets/mv-chat.js) and the
 * Accessibly app's button (bottom right, a third-party app embed we do not control). On a 390 px screen they covered the
 * ends of the main buttons ("Next: your logo or words", "Design one for yourself", the Studio's sticky button row), and a
 * tap on the right end of a button opened the accessibility menu.
 *
 * Under 750 px wide:
 *   - a sticky button row at the bottom of the screen lifts both buttons above it (--mv-lift);
 *   - while a button or a link at least 120 x 36 px (main buttons, product cards, the guarantee link) is under one of them, that one slides to a 14 px tab
 *     at the screen edge (class mv-tuck). The tab is still the button: a tap opens the chat or the accessibility menu.
 * Styles: snippets/mv-float.liquid.
 */
(function () {
  const PHONE = window.matchMedia('(max-width: 749px)');
  const floats = () => [document.getElementById('accessiblyAppWidgetButton'), document.querySelector('.mvc:not(.is-open)')].filter(Boolean);
  // A float's place when not tucked: the tuck is a horizontal translate, so the untucked box is the same box moved back.
  const home = (f) => { const r = f.getBoundingClientRect(), dx = f.classList.contains('mv-tuck') ? (f._mvShift || 0) : 0; return { l: r.left - dx, r: r.right - dx, t: r.top, b: r.bottom }; };
  const hit = (a, b) => Math.min(a.r, b.right) - Math.max(a.l, b.left) > 2 && Math.min(a.b, b.bottom) - Math.max(a.t, b.top) > 2;
  let queued = false;
  function check() {
    queued = false;
    const fs = floats();
    if (!PHONE.matches) { fs.forEach((f) => f.classList.remove('mv-tuck')); document.documentElement.style.removeProperty('--mv-lift'); return; }
    // A sticky row of buttons at the bottom (the Studio's .sv-wo__go and any like it).
    let lift = 0;
    document.querySelectorAll('.sv-wo__go, [data-sticky-cta]').forEach((bar) => {
      const cs = getComputedStyle(bar), r = bar.getBoundingClientRect();
      if (!/sticky|fixed/.test(cs.position) || r.height === 0 || r.bottom < innerHeight - 2 || r.top > innerHeight) return;
      lift = Math.max(lift, Math.round(innerHeight - r.top) + 8);
    });
    document.documentElement.style.setProperty('--mv-lift', `${lift}px`);
    const big = [...document.querySelectorAll('button, a, .sv-door, input[type="submit"]')]
      .filter((b) => { if (fs.some((f) => f.contains(b))) return false; const r = b.getBoundingClientRect(); return r.width >= 120 && r.height >= 36 && r.bottom > 0 && r.top < innerHeight; })
      .map((b) => b.getBoundingClientRect());
    fs.forEach((f) => {
      const on = big.some((r) => hit(home(f), r));
      if (on && !f.classList.contains('mv-tuck')) {
        const r = f.getBoundingClientRect(), left = r.left < innerWidth / 2;
        // Leave a 14 px tab at the screen edge.
        f._mvShift = left ? -(r.right - 14) : innerWidth - 14 - r.left;
        f.style.setProperty('--mv-shift', `${f._mvShift}px`);
      }
      f.classList.toggle('mv-tuck', on);
    });
  }
  const queue = () => { if (!queued) { queued = true; requestAnimationFrame(check); } };
  addEventListener('scroll', queue, { passive: true });
  addEventListener('resize', queue);
  PHONE.addEventListener && PHONE.addEventListener('change', queue);
  // The app's button and the Studio's screens arrive after load: watch the page for a while, then every second.
  new MutationObserver(queue).observe(document.documentElement, { childList: true, subtree: true });
  setInterval(queue, 1000);
  queue();
})();
